import NotificationManager from "../../common/notification/NotificationManager";
import { LOGIN_NOTIFICATION } from "../../utils/constants/notification";
import { store } from "../../redux/store/store";
import {
  resetCpmMetadata,
  resetCpmUser,
  updateAuthDataForTenantConf,
} from "../../redux/feature/settings/configurations-slice";
import { displayError, processDialogEventForTenant, queryParams, tenantConfOrDisplayError } from "./DialogCommons";
import { restoreConsole } from "../logger";

const dialogLogoutUrl = () => window.location.origin + "/login/logout.html";

function displayLogoutSuccess(message: string = "Logout success") {
  NotificationManager.addNotification({
    key: LOGIN_NOTIFICATION,
    message: message,
    title: "Logout",
    type: "success",
    closable: true,
    removeOnClose: true,
    isTemporary: true,
  });
}

export const logout = async (tenantId: string): Promise<void> => {
  let loginDialog: Office.Dialog;

  return new Promise<void>((resolve, reject) => {
    const tenantConfiguration = tenantConfOrDisplayError(tenantId);

    if (tenantConfiguration?.authData) {
      const loginData = tenantConfiguration.authData;
      const dialogLoginUrlWithParams = `${dialogLogoutUrl()}?id_token=${loginData.id_token}&${queryParams(tenantId)}`;
      Office.context.ui.displayDialogAsync(
        dialogLoginUrlWithParams,
        { height: 65, width: 30, promptBeforeOpen: false }, //don't factorize me there's a bug preventing dialog to reopen
        (result) => {
          if (result.status === Office.AsyncResultStatus.Failed) {
            displayError("Logout Error", `${result.error.code} ${result.error.message}`);
            reject(new Error("Logout Error"));
          } else {
            loginDialog = result.value;
            loginDialog.addEventHandler(Office.EventType.DialogMessageReceived, processLogoutMessage);
            loginDialog.addEventHandler(Office.EventType.DialogEventReceived, processLogoutDialogEvent);
            restoreConsole();
          }
        }
      );
    } else {
      displayLogoutSuccess("No enough auth information to request logout");
      resolve();
    }

    function processLogoutMessage(arg: { message: string; origin: string }) {
      let messageFromDialog = JSON.parse(arg.message);
      loginDialog.close();
      store.dispatch(updateAuthDataForTenantConf({ authData: undefined, tenantId: tenantId }));
      store.dispatch(resetCpmUser(tenantId));
      store.dispatch(resetCpmMetadata(tenantId));
      if (messageFromDialog.status === "success") {
        const logoutResponse = messageFromDialog.result;
        if (!logoutResponse.error) {
          displayLogoutSuccess();
        } else {
          displayError("Logout Error", logoutResponse.error_description);
        }
      } else {
        // Something went wrong with authentication or the authorization of the web application.
        displayError("Logout Error", messageFromDialog.result);
      }
      resolve();
    }

    function processLogoutDialogEvent(arg: { error: number }) {
      processDialogEventForTenant(arg, tenantId);
    }
  });
};
